module.exports = __webpack_public_path__ + "static/media/PATS_7-634w.e8f210cb.png";